<template>
  <aside
    :class="{
      'left-sidebar': true,
      'sidebar-active': showContextMenu,
      'is-showing-qr-code-panel': isShowingQRCodePanel
    }"
    data-sidebarbg="skin5"
    id="left-sidebar"
  >
    <!-- Sidebar navigation-->
    <div
      class="exit-presenting-mode-overlay"
      id="context-exit-overlay"
      :class="{'overlay-presenting': $store.getters.isPresenting}"
    />
    <nav
      class="sidebar-nav vertical layout end-justified"
      style="height: 100%; z-index: 999; background: #2f323e;
    transform: translate(0);"
    >
      <ul id="sidebarnav" class="in">
        <!-- Stop presenting -->
        <li
          class="sidebar-item pointer"
          @click.stop="stopPresenting"
          v-if="!$store.state.isPlayDemoMode"
        >
          <a class="sidebar-link-custom sidebar-link waves-effect waves-dark">
            <i class="fas fa-times-circle fa-fw sidebar-link-icon" />
            <span class="hide-menu nav-left-text">Stop presenting</span>
          </a>
        </li>

        <!-- Devider -->
        <div class="devider" />

        <BackstageSetting v-if="!isNewPresentation" />

        <!-- Switch to windowed view -->
        <li
          class="sidebar-item pointer"
          @click.stop="toggleWindowedMode"
          v-if="_checkShowSwitchScreen()"
        >
          <a class="sidebar-link-custom sidebar-link waves-effect waves-dark">
            <span v-if="screenState == 1" class="horizontal layout center">
              <i class="far fa-window-maximize fa-fw sidebar-link-icon" />
              <span class="hide-menu nav-left-text">Switch to windowed view</span>
            </span>
            <span v-if="screenState == 2" class="horizontal layout center">
              <i class="fas fa-expand-alt fa-fw sidebar-link-icon" />
              <span class="hide-menu nav-left-text">Switch to full screen</span>
            </span>
          </a>
        </li>

        <!-- Profanity filter -->
        <li
          class="sidebar-item pointer"
          @click.stop="toggleProfanityFilter()"
          v-if="profanityFilterVisible"
        >
          <a class="sidebar-link-custom sidebar-link waves-effect waves-dark">
            <span class="horizontal layout center">
              <i class="fas fa-asterisk fa-fw sidebar-link-icon" />
              <span
                class="hide-menu nav-left-text"
                v-if="!presentation.filteringProfanity"
              >Filter profanity
              </span>
              <span
                class="hide-menu nav-left-text"
                v-else
              >Allow profanity
              </span>
            </span>
          </a>
        </li>

        <!-- Show/Hide result -->
        <li
          class="sidebar-item pointer"
          @click.stop="editSettings(1)"
          v-if="$store.state.slideActive.type == 'multipleChoice'
            || $store.state.slideActive.type == 'imageChoice'
            || $store.state.slideActive.type == 'openEnded'
            || $store.state.slideActive.type == 'scale'
            || $store.state.slideActive.type == 'wordCloud'"
        >
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-if="$store.state.slideActive.hideResult"
          >
            <i class="fas fa-eye sidebar-link-icon" />
            <span class="hide-menu nav-left-text">Show results</span>
          </a>
          <a
            class="sidebar-link waves-effect waves-dark"
            v-if="!$store.state.slideActive.hideResult"
          >
            <i class="fas fa-eye-slash sidebar-link-icon" />
            <span class="hide-menu nav-left-text">Hide results</span>
          </a>
        </li>

        <!-- Show percentage -->
        <li
          class="sidebar-item pointer"
          @click.stop="editSettings(3)"
          v-if="$store.state.slideActive.type == 'multipleChoice' ||
            $store.state.slideActive.type == 'imageChoice'"
        >
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-if="$store.state.slideActive.showPercentage"
          >
            <span class="percentage-number-icon sidebar-link-icon">123</span>
            <span
              class="hide-menu nav-left-text percentage-number-text"
            >Show results in absolute numbers</span>
          </a>
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-if="!$store.state.slideActive.showPercentage"
          >
            <i class="fas fa-percent fa-fw sidebar-link-icon" />
            <span
              class="hide-menu nav-left-text percentage-number-text"
            >Show results in percentage</span>
          </a>
        </li>

        <!-- Show scale average line -->
        <li
          class="sidebar-item pointer item-hover"
          @click.stop="toggleShowAverageLine"
          v-if="$store.state.slideActive.type == 'scale' && $store.state.slideActive.scale"
        >
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-if="$store.state.slideActive.scale.showAverage"
          >
            <i class="fas fa-sliders-h sidebar-link-icon" />
            <span class="hide-menu nav-left-text">Hide average line</span>
          </a>
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-else
          >
            <i class="fas fa-sliders-h sidebar-link-icon" />
            <span class="hide-menu nav-left-text">Show average line</span>
          </a>
        </li>

        <!-- Stop Submission -->
        <li class="sidebar-item pointer item-hover" @click.stop="editSettings(2)">
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-if="$store.state.slideActive.stopSubmission &&
              ($store.state.slideActive.type == 'multipleChoice'
                || $store.state.slideActive.type == 'imageChoice'
                || $store.state.slideActive.type == 'openEnded'
                || $store.state.slideActive.type == 'scale'
                || $store.state.slideActive.type == 'wordCloud')"
          >
            <i class="fas fa-lock-open sidebar-link-icon" />
            <span class="hide-menu nav-left-text">Unlock submission</span>
          </a>
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-if="!$store.state.slideActive.stopSubmission &&
              ($store.state.slideActive.type == 'multipleChoice' ||
                $store.state.slideActive.type == 'imageChoice' ||
                $store.state.slideActive.type == 'openEnded' ||
                $store.state.slideActive.type == 'scale' ||
                $store.state.slideActive.type == 'wordCloud')"
          >
            <i class="fas fa-lock sidebar-link-icon" />
            <span class="hide-menu nav-left-text">Lock submission</span>
          </a>
        </li>

        <!-- Time to answer -->
        <li
          class="sidebar-item pointer change-layout-live"
          @mouseenter="_openSecondLevelMenuTimeLimit"
          @mouseleave="_closeSecondLevelMenuTimeLimit"
          v-if="hasTimeLimitOption && hasTimeLimit"
        >
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
          >
            <i class="fas fa-hourglass-half sidebar-link-icon" />
            <span class="hide-menu nav-left-text">Limit time to answer</span>
            <i class="fas fa-chevron-right context-menu-arrow-right" />
          </a>
          <ul
            class="context-menu-second-level time-limit-options"
            ref="second-level-menu"
            :class="{'d-block': openSecondLevelMenuTimeLimit}"
          >
            <li
              class="sidebar-item pointer"
              v-for="item in timeLimitOptions"
              :key="item.label"
              @click="changeTimeToAnswer(item.seconds)"
            >
              <a class="pl-2 sidebar-link waves-effect waves-dark sidebar-link-custom">
                <span class="hide-menu nav-left-text">{{ item.label }}</span>
              </a>
            </li>
          </ul>
        </li>

        <!-- Change layout live -->
        <li
          class="sidebar-item pointer change-layout-live"
          @mouseenter="_openSecondLevelMenu"
          @mouseleave="_closeSecondLevelMenu"
        >
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-if="isSettingChangeLayoutVisible"
          >
            <i class="fas fa-comments sidebar-link-icon" />
            <span class="hide-menu nav-left-text">Change layout</span>
            <i class="fas fa-chevron-right context-menu-arrow-right" />
          </a>
          <ul
            class="context-menu-second-level"
            ref="second-level-menu"
            :class="{'d-block': openSecondLevelMenu}"
            v-if="isMultipleOrImageChoice"
          >
            <li
              class="sidebar-item pointer"
              :class="{'active': item.type == slideActive.typeChart}"
              v-for="item in chartTypes"
              :key="item.type"
              @click.stop="changeType(item, slideActive.type)"
            >
              <a class="pl-2 sidebar-link waves-effect waves-dark sidebar-link-custom">
                <i :class="item.icon" v-if="item.type != 'donutChart'" />
                <img
                  src="../../assets/images/icon/donutcharticon.png"
                  class="donut-chart-icon"
                  v-show="item.type == 'donutChart'"
                >
                <img
                  src="../../assets/images/icon/donutcharticon-active.png"
                  class="donut-chart-icon--active"
                  v-show="item.type == 'donutChart'"
                >
                <span class="hide-menu nav-left-text">{{ item.name }}</span>
              </a>
            </li>
          </ul>
          <ul
            class="context-menu-second-level"
            :class="{'d-block': openSecondLevelMenu}"
            v-if="slideActive.type == 'openEnded'"
          >
            <li
              class="sidebar-item pointer"
              :class="{'active': item.type == $store.state.slideActive.layout}"
              v-for="item in layouts"
              :key="item.type"
              @click.stop="changeType(item,$store.state.slideActive.type)"
            >
              <a class="sidebar-link waves-effect waves-dark sidebar-link-custom">
                <i :class="item.icon" />
                <span class="hide-menu nav-left-text">{{ item.name }}</span>
              </a>
            </li>
          </ul>
        </li>
        <!-- Show QR code   -->
        <li class="sidebar-item pointer" @click.stop="showQrcode()">
          <a class="sidebar-link waves-effect waves-dark sidebar-link-custom">
            <i class="fas fa-qrcode fa-fw sidebar-link-icon" />
            <span
              class="hide-menu nav-left-text"
              v-if="!$store.state.isQRCodeVisible"
            >Show QR code</span>
            <span class="hide-menu nav-left-text" v-if="$store.state.isQRCodeVisible">
              Hide QR code
            </span>
          </a>
        </li>
        <!-- Hide instruction bar -->
        <li class="sidebar-item pointer" @click.stop="toggleHideInstructionBar()">
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-if="$store.state.slideActive.type != 'document' &&
              $store.state.slideActive.type != 'googleSlides'"
          >
            <i class="fas fa-info-circle fa-fw sidebar-link-icon" />
            <span
              class="hide-menu nav-left-text"
              v-if="$store.state.presentation.hideInstructionBar"
            >Show instruction bar</span>
            <span
              class="hide-menu nav-left-text"
              v-if="!$store.state.presentation.hideInstructionBar"
            >Hide instruction bar</span>
          </a>
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-if="$store.state.slideActive.type == 'document' ||
              $store.state.slideActive.type == 'googleSlides'"
          >
            <i class="fas fa-info-circle fa-fw sidebar-link-icon" />
            <span
              class="hide-menu nav-left-text"
              v-if="$store.state.presentation.hideIntroBarDocument"
            >Show instruction bar</span>
            <span
              class="hide-menu nav-left-text"
              v-if="!$store.state.presentation.hideIntroBarDocument"
            >Hide instruction bar</span>
          </a>
        </li>

        <!-- Private Mode  -->
        <PrivateModeSetting />
      </ul>
    </nav>
    <!-- End Sidebar navigation -->
  </aside>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import screenfull from 'screenfull'
import * as Sentry from '@sentry/vue'
import {
  SET_CURRENT_SLIDE_MODE,
  FULL_SCREEN_MODE,
  WINDOWED_MODE,
  EDIT_MODE,
} from '@/vuex/types'
import Config from '@/config'
import Util from '@/util'
import Socket from '@/socket'
import Constant from '@/constant'
import EventBus from '@/eventBus'
import gaCategories from '@/constant/gaCategories'
import SlideApi from '@/api/slide'

import BackstageSetting from '@/components-v2/presentation-editor/context-menu/BackstageSetting.vue'
import PrivateModeSetting from '@/components-v2/presentation-editor/context-menu/PrivateModeSetting.vue'

const tracker = Util.gaTrackEventFactory({
  eventCategory: Config.US_PRESENTING_MODE,
  eventLabel: Config.LABEL_USER_INTERACTION,
}).bind(Util)

export default {
  components: {
    BackstageSetting,
    PrivateModeSetting,
  },
  props: ['showContextMenu', 'isShowingQRCodePanel'],
  data() {
    return {
      chartTypes: [],
      layouts: [],
      openSecondLevelMenu: false,
      openSecondLevelMenuTimeLimit: false,
      screenState: '',
      timeLimitOptions: [
        { label: '45 seconds', seconds: 45 },
        { label: '90 seconds', seconds: 90 },
        { label: '3 minutes', seconds: 180 },
        { label: '5 minutes', seconds: 300 },
        { label: '10 minutes', seconds: 600 },
        { label: '15 minutes', seconds: 900 },
        { label: '20 minutes', seconds: 1200 },
      ],
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
      isNewPresentation: (state) => state.isNewPresentation,
      currentUser: (state) => state.currentUser,
    }),
    hasTimeLimitOption() {
      return this.$store.state.slideActive.type === 'imageChoice' ||
       this.$store.state.slideActive.type === 'multipleChoice' ||
       this.$store.state.slideActive.type === 'openEnded' ||
       this.$store.state.slideActive.type === 'scale' ||
       this.$store.state.slideActive.type === 'wordCloud'
    },
    hasTimeLimit() {
      return !!this.$store.state.slideActive.hasTimeLimit
       && !JSON.parse(this.$store.state.presentation.audiencePacing)
    },
    profanityFilterVisible() {
      const slideTypes = ['openEnded', 'wordCloud', 'question', 'pickAnswer', 'leaderboard', 'spinnerWheel', 'ideas']
      return slideTypes.includes(this.slideActive.type)
    },
    backgroundMusicToggleVisible() {
      const slideTypes = ['pickAnswer', 'leaderboard']
      return slideTypes.includes(this.slideActive.type)
    },
    isSettingChangeLayoutVisible() {
      const slideTypes = ['multipleChoice', 'openEnded', 'imageChoice']
      return slideTypes.includes(this.slideActive.type)
    },
    isMultipleOrImageChoice() {
      const slideTypes = ['multipleChoice', 'imageChoice']
      return slideTypes.includes(this.slideActive.type)
    },
  },
  created() {
    Object.keys(Constant.chartTypes).forEach((item) => {
      this.chartTypes.push(Constant.chartTypes[item])
    })
    Object.keys(Constant.openEndedLayout).forEach((item) => {
      this.layouts.push(Constant.openEndedLayout[item])
    })
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction']),
    _checkShowSwitchScreen() {
      if (!screenfull || this.$store.state.isPlayDemoMode) {
        return false
      }

      if (this.$store.state.currentSlideMode === 'fullScreenMode') {
        this.screenState = 1
        return true
      }

      if (this.$store.state.currentSlideMode === 'windowedMode') {
        this.screenState = 2
        return true
      }

      return false
    },
    showQrcode() {
      this.$store.state.isQRCodeVisible = !this.$store.state.isQRCodeVisible
      this.$emit('hideMenu')
      Util.gaTrackEvent(
        'Presentation',
        'Show/Hide QR code',
        'Presenter show/hide QR code',
      )
    },
    toggleShowAverageLine() {
      this.editSettings(14)
    },
    showEditMode() {
      tracker({ eventAction: 'Presenter switch to edit mode using context menu' })
      this.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
      this.$emit('hideFullScreen')
    },
    stopPresenting() {
      const mode = this.$store.getters.isFullScreenMode
        ? WINDOWED_MODE
        : FULL_SCREEN_MODE
      this.$store.dispatch(SET_CURRENT_SLIDE_MODE, mode)
      if (window.innerWidth > 800) {
        this.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
        if (document.fullscreen && document.exitFullscreen) {
          document.exitFullscreen()
        }
      } else {
        this.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
      }
      this.$store.state.isQRCodeVisible = false
      this.$router.replace({
        name: 'PresentationDetail',
        params: { id: this.$store.state.presentation.id },
      })
      EventBus.$emit('close-backstage-window')
      this.$emit('hideFullScreen')

      // TODO:
      // - Create "start" "stop" presentation API and move the scope below to server side
      // - There is duplicated code in Middle.vue (stopPresenting), move it to server side too.
      if (this.$store.state.slideActive.type == 'pickAnswer') {
        if (!this.$store.state.isAdmin) {
          this.$http.put(
            Config.api.updateSlide + this.$store.state.slideActive.id,
            {
              quizStatus: Constant.QuizStatuses.LOBBY_SCREEN,
              socketId: Socket.getSocketId(),
              accessCode: this.$store.state.presentation.uniqueAccessCode,
              activeSlide: this.$store.state.slideActive.id,
              presentationId: this.$store.state.presentation.id,
              presenting: false,
            },
          ).then(() => {}, () => {
            this.$store.dispatch('setSyncPresentation', 3)
          })
        }
      }

      if (
        this.$store.state.presentation.id &&
        !this.$store.state.isAdmin &&
        !this.$store.state.sharePresentation
      ) {
        const idLastSlide = Util.getLastSlide(
          this.$store.state.presentation.slides,
        )
        const payload = {
          presenting: false,
          socketId: Socket.getSocketId(),
          activeSlidePreseting: this.$store.state.slideActive.id,
          activeSlideAccessCode: this.$store.state.presentation.uniqueAccessCode,
        }
        if (
          idLastSlide &&
          idLastSlide != this.$store.state.presentation.lastSlide
        ) {
          payload.lastSlide = idLastSlide
          this.$store.state.presentation.lastSlide = idLastSlide
        }
        this.$http
          .put(
            Config.api.updatePresentation + this.$store.state.presentation.id,
            payload,
          )
          .then(() => {}, (err) => {
            Sentry.captureException(err)
          })
      }
      // END OF TODO

      Util.gaTrackEvent(
        'Presentation',
        'Stop presenting',
        'Presenter stop presenting',
      )
    },
    async toggleWindowedMode() {
      try {
        if (this.$store.getters.isFullScreenMode) {
          screenfull.exit()

          this.$store.dispatch(SET_CURRENT_SLIDE_MODE, WINDOWED_MODE)

          // AHA-890 Remember fullscreen setting
          const payload = {
            fullscreen: false,
          }
          const result = await this.$http
            .put(Config.api.updateUserSettings, payload)
          this.$store.state.currentUser.rememberSettings
            = result.body.rememberSettings

          Util.gaTrackEvent('Presentation', 'Switch screen mode', 'Presenter switch to windowed mode')
          return
        }

        if (this.$store.getters.isWindowedMode) {
          screenfull.request()

          this.$store.dispatch(SET_CURRENT_SLIDE_MODE, FULL_SCREEN_MODE)

          // AHA-890 Remember fullscreen setting
          const payload = {
            fullscreen: true,
          }
          const result = await this.$http
            .put(Config.api.updateUserSettings, payload)
          this.$store.state.currentUser.rememberSettings
            = result.body.rememberSettings

          Util.gaTrackEvent('Presentation', 'Switch screen mode', 'Presenter switch to full screen mode')
        }
      } catch {
        // do nothing
      }
    },
    hideContextMenu() {
      this.$emit('hideFullScreen')
    },
    editSettings(type) {
      this.$emit('hideFullScreen')
      const params = {
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        socketId: Socket.getSocketId(),
      }
      if (type === 1) {
        params.hideResult = !this.$store.state.slideActive.hideResult
        this.updateSlideActiveAction({
          hideResult: params.hideResult,
        })
      } else if (type === 2) {
        params.stopSubmission = !this.$store.state.slideActive.stopSubmission
        this.updateSlideActiveAction({
          stopSubmission: params.stopSubmission,
        })
        if (!params.stopSubmission && this.$store.state.slideActive.timeToAnswer) {
          const stopSubmissionTime = new Date().getTime() +
            this.$store.state.slideActive.timeToAnswer * 1000
          this.updateSlideActiveAction({
            stopSubmissionTime,
          })
          params.stopSubmissionTime = stopSubmissionTime
          params.timeToAnswer = this.$store.state.slideActive.timeToAnswer
        }
      } else if (type === 3) {
        params.showPercentage = !this.$store.state.slideActive.showPercentage
        this.updateSlideActiveAction({
          showPercentage: params.showPercentage,
        })
      } else if (type === 14) {
        params.scale = {
          ...this.$store.state.slideActive.scale,
          showAverage: !this.$store.state.slideActive.scale.showAverage,
        }
        this.updateSlideActiveAction({
          scale: params.scale,
        })
      }
      this.$store.dispatch('setSyncPresentation', 1)
      params.presenting = this.$store.getters.isPresenting
      this.$http
        .put(Config.api.updateSlide + this.$store.state.slideActive.id, params)
        .then(
          () => {
            if (type === 1) {
              Util.gaTrackEvent(
                'Slide',
                'Edit setting',
                'Presenter edit setting hide result',
                this.$store.state.slideActive.hideResult,
              )
            } else if (type === 2) {
              Util.gaTrackEvent(
                'Slide',
                'Edit setting',
                'Presenter edit setting stop submission',
                this.$store.state.slideActive.stopSubmission,
              )
            } else if (type === 3) {
              Util.gaTrackEvent(
                'Slide',
                'Edit setting',
                'Presenter edit setting show percentage chart',
              )
            } else if (type === 14) {
              const action = this.$store.state.slideActive.scale.showAverage ? 'Show' : 'Hide'
              Util.gaTrackEvent(
                'Presentation > Context Menu > Show Average Line',
                `${action} Average Line`,
                'Presenter show/hide Average Line',
              )
            }
            this.$store.dispatch('setSyncPresentation', 2)
          },
          () => {
            this.$store.dispatch('setSyncPresentation', 3)
          },
        )
    },

    async changeType(item, type) {
      const payload = {}
      if (type === 'multipleChoice' || type === 'imageChoice') {
        payload.typeChart = item.type
        this.updateSlideActiveAction({
          typeChart: item.type,
        })
      } else {
        payload.layout = item.type
        this.updateSlideActiveAction({
          layout: item.type,
        })
      }
      payload.presentationId = this.$store.state.presentation.id
      payload.accessCode = this.$store.state.presentation.uniqueAccessCode
      payload.socketId = Socket.getSocketId()
      this.setSyncLoadingAction(1)
      Util.uploadSlide(
        this.$store.state.slideActive,
        this.$store.state.presentation,
      )
      payload.presenting = this.$store.getters.isPresenting || this.$store.getters.isBackstage
      try {
        await SlideApi.updateSlideById(this.slideActive.id, payload)
        this.setSyncLoadingAction(2)
        Util.gaTrackEvent(
          gaCategories.PRESENTING_MODE,
          'Context menu > Change layout',
          `Slide type: ${type} - Layout: ${item.type}`,
        )
      } catch (error) {
        this.setSyncLoadingAction(3)
      }
    },

    toggleProfanityFilter() {
      this.presentation.filteringProfanity = !this.presentation.filteringProfanity
      const payload = {
        filteringProfanity: this.presentation.filteringProfanity,
      }
      Util.gaTrackEvent(
        gaCategories.PRESENTING_MODE,
        `Menu > Profanity Filter > ${this.presentation.filteringProfanity ? 'Filter on' : 'Filter off'}`,
      )
      this._updatePresentation(payload)
    },

    toggleHideInstructionBar() {
      const slideTypes = ['document', 'googleSlides', 'freestyle']
      let payload = {}
      if (slideTypes.includes(this.slideActive.type)) {
        this.presentation.hideIntroBarDocument = !this.presentation.hideIntroBarDocument
        payload = {
          hideIntroBarDocument: this.presentation.hideIntroBarDocument,
        }
      } else {
        this.presentation.hideInstructionBar = !this.presentation.hideInstructionBar
        payload = {
          hideInstructionBar: this.presentation.hideInstructionBar,
        }
      }
      Util.gaTrackEvent(
        gaCategories.PRESENTING_MODE,
        'Menu > Show/ Hide instruction bar',
      )
      this._updatePresentation(payload)
    },

    _updatePresentation(payload) {
      this.$http.put(
        Config.api.updatePresentation + this.presentation.id,
        payload,
      ).then(() => {}, () => {})
    },

    changeTimeToAnswer(value) {
      this.updateSlideActiveAction({
        timeToAnswer: value,
      })
      EventBus.$emit('resetTimeToAnswer')
      Util.gaTrackEvent('Slide update', 'Update time limit from Menu', value)
    },

    _openSecondLevelMenu() {
      this.openSecondLevelMenu = true
      this._setBackdropZ('99')
    },

    _closeSecondLevelMenu() {
      this.openSecondLevelMenu = false
      this._setBackdropZ('999')
    },

    _openSecondLevelMenuTimeLimit() {
      this.openSecondLevelMenuTimeLimit = true
      this._setBackdropZ('99')
    },

    _closeSecondLevelMenuTimeLimit() {
      this.openSecondLevelMenuTimeLimit = false
      this._setBackdropZ('999')
    },

    _setBackdropZ(z) {
      const backdrop = document.getElementsByClassName('backdrop')[0]
      if (backdrop) {
        backdrop.style.zIndex = z
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.left-sidebar {
  padding-top: 0;
  transition: transform 0.3s ease;
  transform: translate(-250px);
  background: #2f323e;
  left: -250px;
  position: fixed;
  z-index: 900;
  width: 250px;
  .sidebar-nav ul {
    padding-bottom: 50px;
    @media (max-width: 812px) and (orientation: landscape) {
      padding-bottom: 90px;
    }
  }
  .sidebar-item {
    width: unset;
    .sidebar-link {
      &.sidebar-link-custom {
        white-space: normal;
      }
      .donut-chart-icon--active {
        display: none;
      }
      &:hover {
        .fas, .far {
          color: $primary-color;
        }
        .donut-chart-icon--active {
          display: block;
        }
        .donut-chart-icon {
          display: none;
        }
      }
      .sidebar-link-icon {
        font-size: 20px;
        margin-right:12px;
      }
      .percentage-number-icon {
        font-size: 80%;
        width: 29.65px;
        margin-right: 17px;
      }
      .percentage-number-text {
        white-space: pre-line;
      }
    }
    .active {
      background-color: rgba(0, 0, 0, 0.07);
    }
    .nav-left-text {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -ms-flex: 1;
      flex: 1;
      font-size: 16px;
    }
  }

  &.sidebar-active {
    transform: translate(0);
    overflow: visible;
    left: 0;
    .sidebar-nav::after {
      width: 400vw;
      height: 100%;
      opacity: 1;
      overflow-x: hidden;
    }
  }
  &.is-showing-qr-code-panel {
    transform: translate(0) scale(0.8);
    &.sidebar-active {
      transform: translate(92%) scale(0.8);
    }
  }
}
.sidebar-nav {
  position: relative;
  .devider {
    margin: 0;
  }
}

.sidebar-nav::after {
  position: absolute;
  content: "";
  display: block;
  background-color: rgba(0, 0, 0, 0.7);
  opacity: 0;
  width: 0;
  height: 0;
  left: 100%;
  top: 0;
  z-index: 1000;
  -webkit-transition: opacity 0.2s ease-in-out;
  transition: opacity 0.2s ease-in-out;
}

.sidebar-nav ul .sidebar-item .sidebar-link {
  padding: 10px 15px 10px 12px;
  .context-menu-arrow-right {
    text-align: right;
    width: 15px;
    font-size: 15px;
  }
}

.change-layout-live {
  position: relative;
}

.context-menu-second-level {
  display: none;
  position: absolute;
  top: 0;
  z-index: 1001;
  height: fit-content;
  left: 100%;
  background: #2f323e;
  font-size: 15px;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  width: 249px;
  .donut-chart-icon, .donut-chart-icon--active {
    width: 27px;
    height: 27px;
    margin: 0 4px;
  }
}

.time-limit-options {
  top: -90px;
}
</style>
